export { default as RequiredHeadTags } from './RequiredHeadTags';
export { default as HrefLangTags } from './HrefLangTags';
